exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_subNode__rWgZM {\n  margin: 4px;\n}\n\n.styles_subNode__rWgZM [class*='button-fill'] {\n  --f7-button-bg-color: var(--subnode-swiper-button-bg-color);\n  --f7-button-text-color: var(--subnode-swiper-button-text-color);\n  --f7-button-box-shadow: var(--subnode-swiper-button-box-shadow);\n  --f7-button-border-width: var(--subnode-swiper-button-border-width);\n  --f7-button-border-color: var(--subnode-swiper-button-border-color);\n}", ""]);

// Exports
exports.locals = {
	"subNode": "styles_subNode__rWgZM"
};